import dependencyInjection from "@common/util/dependencyInjection";

import { FeaturesService } from "../../services/Features.service";

interface Services {
  featuresService: FeaturesService;
}

const featuresService = new FeaturesService();

/// The Info > Features pages that used to consume this DI setup are gone (superseded by the
/// what's-new interjected row), but useChangeLogNotificationsApiConsumer.ts still imports
/// useFeaturessDeps from here for the global unread-notifications fetch.
const [, useFeaturessDeps] = dependencyInjection<Services>({
  services: {
    featuresService,
  },
});

export { useFeaturessDeps };
